import React, { Component } from 'react'
import { withRouter}  from 'react-router'
import "./DisclaimerSection.less"

class DisclaimerSection extends Component {
    constructor(props) {
        super(props);
    }

    goToPage = (url) => {
        window.open(url);
    }

    render() {
        return <div className="disclaimer">By pressing the "{this.props.buttonText}" button, you agree to ServiceGrace <div className="link"
            onClick={() => this.goToPage('/terms-of-use')}>Terms of Use</div> and <div className="link" onClick={() => this.goToPage('/privacy-policy')}>Privacy Policy.</div>
        </div>
    }
}

export default withRouter(DisclaimerSection);